import { Rank } from './types'

export interface GA4GeneralProps {
  panelName?: string | null
  panelClass?: string | null
  panelRank?: Rank | null
  componentName?: string | null
  componentClass?: string | null
  componentRank?: Rank | null
  resourceId?: string | null
}

interface IGA4Event extends GA4GeneralProps {
  event: string
}

export class GA4Event {
  event: string
  ga4_panel_name?: string | null
  ga4_panel_class?: string | null
  ga4_panel_rank?: Rank | null
  ga4_component_name?: string | null
  ga4_component_class?: string | null
  ga4_component_rank?: Rank | null
  ga4_resource_id?: string | null

  constructor({
    event,
    panelName = null,
    panelClass = null,
    panelRank = null,
    componentName = null,
    componentClass = null,
    componentRank = null,
    resourceId = null,
  }: IGA4Event) {
    this.event = event
    this.ga4_panel_name = panelName
    this.ga4_panel_class = panelClass
    this.ga4_panel_rank = panelRank
    this.ga4_component_name = componentName
    this.ga4_component_class = componentClass
    this.ga4_component_rank = componentRank
    this.ga4_resource_id = resourceId
  }
}
